module.exports = __webpack_public_path__ + "img/mockup_ignoto_mac.d73fbcc2.png";